import React from 'react';
import { WixDesignSystemsMaskingContext } from './context';
import { maskingClassNames } from './constants';
export const WixDesignSystemsMaskingProvider = ({ children, }) => (React.createElement(WixDesignSystemsMaskingContext.Provider, { value: { maskingClassNames } }, children));
WixDesignSystemsMaskingProvider.displayName = 'WixDesignSystemsMaskingProvider';
//# sourceMappingURL=WixDesignSystemsMaskingProvider.js.map